import type React from 'react';

import { PetitionUnderReviewBanner } from 'src/app/shared/components/banners/petitionUnderReview';

import { usePageBanner } from './hooks/usePageBanner';

export const PageBanner: React.FC = () => {
	const {
		data: { showUnderReviewBanner },
	} = usePageBanner();

	if (!showUnderReviewBanner) return null;

	return <PetitionUnderReviewBanner />;
};
